@if (node(); as _node) {
	<p>{{ _node.userMessage }}</p>

	@if (shouldShowButton()) {
		@let _titleText = isExpanded() ? 'Collapse node' : 'Expand node';

		<button
			class="ada-btn ada-btn-sm ada-btn-icon ada-btn-solid ada-btn-no-margin ada-btn-no-padding"
			[attr.aria-label]="_titleText"
			[attr.data-testid]="`ada-llm-history-node-toggleButton-${_node.nodeId}`"
			[attr.title]="_titleText"
			(click)="$event.stopPropagation(); toggle()"
		>
			<ada-icon icon="{{ isExpanded() ? 'faMinus' : 'faPlus' }}" />
		</button>
	}
}
